module.exports = __webpack_public_path__ + "img/online-meeting-with-marking-team-2021-08-30-01-21-42-utc.94f6f761.png";